import { useState } from "react";

export default function UrlInput({ onSubmit, loading }) {
  const [url, setUrl] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = url.trim();
    if (trimmed) onSubmit(trimmed);
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <form onSubmit={handleSubmit} className="flex gap-3">
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Paste any Instagram URL — post, reel, carousel, profile…"
          disabled={loading}
          className="
            flex-1 px-5 py-4 rounded-xl text-base
            bg-[#1a1a1a] border border-[#2e2e2e]
            text-white placeholder-[#555]
            focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
            disabled:opacity-50 transition
          "
        />
        <button
          type="submit"
          disabled={loading || !url.trim()}
          className="
            px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap
            bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-700
            disabled:opacity-40 disabled:cursor-not-allowed
            transition-colors
          "
        >
          {loading ? "Processing…" : "Download & Analyze"}
        </button>
      </form>
      <p className="mt-3 text-center text-sm text-[#555]">
        Supports posts, reels, carousels, profiles
      </p>
    </div>
  );
}
